import React from 'react';
import { Step, Locale } from 'react-joyride';
import BaseTour, { useDefaultTourLocale } from './BaseTour';
import { useTranslation } from 'react-i18next';

interface LegacyVaultTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const LegacyVaultTour: React.FC<LegacyVaultTourProps> = ({ isRunning, onComplete }) => {
    const defaultTourLocale = useDefaultTourLocale();
    const { t } = useTranslation();

    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: 12, fontSize: 18, fontWeight: 600 }}>
                        {t('app_tour.legacy_vault.overview.title')}
                    </h3>
                    <p>{t('app_tour.legacy_vault.overview.description')}</p>
                </div>
            ),
            placement: 'center' as const,
            disableBeacon: true,
        },
        {
            target: '#legacyVaultCta',
            content: (
                <div>
                    <h3 style={{ marginBottom: 12, fontSize: 18, fontWeight: 600 }}>
                        {t('app_tour.legacy_vault.go_to_plans.title')}
                    </h3>
                    <p>{t('app_tour.legacy_vault.go_to_plans.description')}</p>
                </div>
            ),
            placement: 'bottom' as const,
        },
        {
            target: '#pricing',
            content: (
                <div>
                    <h3 style={{ marginBottom: 12, fontSize: 18, fontWeight: 600 }}>
                        {t('app_tour.legacy_vault.compare_plans.title')}
                    </h3>
                    <p>{t('app_tour.legacy_vault.compare_plans.description')}</p>
                </div>
            ),
            placement: 'top' as const,
        },
        {
            target: '.lv-select-button',
            content: (
                <div>
                    <h3 style={{ marginBottom: 12, fontSize: 18, fontWeight: 600 }}>
                        {t('app_tour.legacy_vault.select_or_download.title')}
                    </h3>
                    <p>{t('app_tour.legacy_vault.select_or_download.description')}</p>
                </div>
            ),
            placement: 'top' as const,
            spotlightClicks: true,
        },
    ];

    const customLocale: Locale = {
        ...defaultTourLocale,
        skip: t('skip'),
    };

    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="legacy-vault" steps={steps} navigateTo="/dashboard/tools/legacy-vault" customLocale={customLocale} />;
};

export default LegacyVaultTour;
